export enum SEARCH_PARAM_KEY {
  SEARCH_TERM = 'searchTerm',
  BTAG = 'btag',
  CASINO_FIRST = 'casinofirst',
  SIGNUP = 'signup',
  AFF_ID = 'affid',
  SOURCE_ID = 'sourceid',
  SITE_ID = 'siteid',
  A_ID = 'aid',
  BANNER_ID = 'bannerid',
  SOURCE = 'source',
  NAME = 'name',
  REFERER_USER_ID = 'refererUserId',
  REWARD_TYPE_ID = 'rewardTypeId',
  TOKEN = 'token',
  USER = 'user',
  GAME_ID = 'gameId',
  PROVIDER_ID = 'providerId',
  CATEGORY_ID = 'categoryId',
  FILTER_ID = 'filterId',
  CASINO_PROMOTION_TYPE = 'casinoPromotionType',
  SPORT = 'sport',
  EVENT_ID = 'eventId',
  LIST_ID = 'listId',
  CATEGORY_CASINO = 'categoryCasino',
  FILTER_CASINO = 'filterCasino',
  SECTION = 'section',
  SUB_SECTION = 'subsection',
  APP_TOUR = 'appTour',
}
